import { compose } from 'redux';
import withTheme from '@material-ui/styles/withTheme';
import GoogleMapReact from 'google-map-react';

import GoogleMapTheme from 'layout/googleMap.themes';
import { useCurrentUserOrganizationLocationDefaultNordway } from 'app/hooks/useCurrentUser';
import { DEFAULT_MAP_ZOOM } from 'features/wells/wells.constants';

export const GoogleMap = ({
  center,
  zoom = DEFAULT_MAP_ZOOM,
  children,
  theme,
  allowZoom = false,
  ...rest
}) => (
  <GoogleMapReact
    clusterRadius={1}
    defaultCenter={useCurrentUserOrganizationLocationDefaultNordway()}
    bootstrapURLKeys={{ key: 'AIzaSyBQQk_PZzLUCixr_M6FBW2Yg6y9b5lnHI4' }}
    center={center}
    zoom={zoom}
    options={{
      draggableCursor: 'inherit',
      styles: GoogleMapTheme[theme.palette.type],
      disableDefaultUI: true,
      gestureHandling: allowZoom ? undefined : 'none',
      scrollwheel: true,
      panControl: true,
      mapTypeControl: false,
    }}
    {...rest}
  >
    {children}
  </GoogleMapReact>
);

export default compose(withTheme)(GoogleMap);
